import { connect } from "react-redux";

var CurrentUser = require("lib/account/CurrentUser");
var HelpSectionLink = require("components/utility/HelpSectionLink");
var ButtonDropdown = require("components/utility/ButtonDropdown");
var DropDownOptions = require("components/utility/DropDownOptions");
var AltSkillsets = require("lib/academic/AltSkillsets");

@connect(
	(state, props) => {
		return {
		}
	},

	(dispatch, props) => ({
		onChange: (prefsUpdate, message) => {
			// Will get moved to redux at some point (soon, I hope)
			window.wrNotifications.triggerDropDownNotification({
				title: "Information Edited", text: message, icon: "ok-sign"
			});

			var adminID = CurrentUser.get().id;
			var params = { admin: { prefs: prefsUpdate } };

			var newPrefs = _.extend({}, CurrentUser.get().prefs, prefsUpdate);
			CurrentUser.updateLocal({ prefs: newPrefs });

			CurrentUser.api().patchAdmin(adminID, params, $wr.apiHandler(function(response) {

				$(window.document).trigger("standards-updated")
			}.bind(this)));
		}
	})
)
class SkillsetStandardPreference extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("SkillsetStandardPreference");
	}

	buildSelectStandardF(standardKey) {
		return function() {
			this.props.onChange({ skillset_standard: standardKey }, 
				"You successfully changed your standards")

			this.forceUpdate(); // Won't need this when prefs update happens with redux				
		}.bind(this)
	}

	render() {
		var standardOptions = DropDownOptions.Button.Standards({
			buildOptionF: this.buildSelectStandardF,
			showState: true
		});

		var current = CurrentUser.get().prefs.skillset_standard;

		var standardsDropdown = (
			<ButtonDropdown text={ AltSkillsets.getStandardName(current, true) }
				className="standardsPicker">
				{ standardOptions }
			</ButtonDropdown>
		);

		return (
			<div>
				<p className="selectStandardsText">
					Select a standards system to use:
				</p>

				{ standardsDropdown }

			</div>
		)
	}

}


SkillsetStandardPreference.WrappedComponent.propTypes = StrictPropTypes({
	onChange: PropTypes.func.isRequired
});

module.exports = SkillsetStandardPreference;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/SkillsetStandardPreference.js